import { render } from "./GrupoFamaliar.vue?vue&type=template&id=00376a4c"
import script from "./GrupoFamaliar.vue?vue&type=script&lang=js"
export * from "./GrupoFamaliar.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Proyectos\\Front_IOSEP\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__